export default __webpack_public_path__ + "static/media/logo_ths.1ad88e2a.png";